module.exports = __webpack_public_path__ + "af7ae505a9eed503f8b8e6982036873e.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/fontawesome-webfont.woff2
// module id = 1315
// module chunks = 28